<template>
  <detail-layout-two-columns-no-fixed>
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>
    </template>
    <template slot="LeftCol">
      <div class="invoice-step h-full px-4 lg:px-10">
        <step-0-issuer ref="embedded-step-0" class="embedded-step h-full" :is-first-step="isFirstStep" :step="step0" v-model="localValue" />
        <step-1-receiver v-if="form.issuer" ref="embedded-step-1" class="embedded-step h-full mt-4" :is-first-step="isFirstStep" :step="step1" v-model="localValue" @applystep="applystep" />
      </div>
    </template>
    <template slot='RightCol'>
      <slot name="invoice-summary" />
    </template>
    <template slot='layout-extend'>
      <slot name="layout-extend" :valid="form.issuer && form.receiver" />
    </template>
  </detail-layout-two-columns-no-fixed>
</template>

<script>
import { i18n } from '@/i18n'
import waitUntil from '@/services/functions/waitUntil'

import DetailLayoutTwoColumnsNoFixed from '@/components/layout/DetailLayoutTwoColumnsNoFixed.vue'
import Step0Issuer from '@/views/invoices/issuingSteps/Step0Issuer.vue'
import Step1Receiver from '@/views/invoices/issuingSteps/Step1Receiver.vue'

export default {
  name: 'step01-partes',
  components: {
    // Loading,
    DetailLayoutTwoColumnsNoFixed,
    Step0Issuer,
    Step1Receiver
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      localValue: this.value,
      step0: { title: i18n.t('invoices.emisor'), icon: '', description: i18n.t('invoices.invoices_issuing.step0.header') },
      step1: { title: i18n.t('invoices.receptor'), icon: '', description: i18n.t('invoices.invoices_issuing.step1.header') }
    }
  },
  computed: {
    form: function () {
      const step0Form = this.$store.getters['invoicesIssuing/0/form']
      const step1Form = this.$store.getters['invoicesIssuing/1/form']
      return {
        ...step0Form,
        ...step1Form
      }
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },
  watch: {
    value: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    localValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('input', value)
      }
    },
    'form.issuer': async function (value, oldValue) {
      if (value !== oldValue) {
        this.resetStep1()
        // this.prepareStep1()
        if (value) {
          this.$nextTick(async () => {
            await waitUntil(() => !this.isGeneralLoading)
            this.prepareStep1()
            this.$refs['embedded-step-1'].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          })
        }
      }
    }
  },
  mounted () {
    this.prepareStep1()
  },
  methods: {
    prepareStep1: function () {
      if (this.form.issuer && this.$refs['embedded-step-1']) {
        this.$refs['embedded-step-1'].prepareStep()
      }
    },
    resetStep1: function () {
      if (this.$refs['embedded-step-1']) {
        this.$refs['embedded-step-1'].resetForm()
      }
    },
    resetForm: function () {
      this.$refs['embedded-step-0'].resetForm()
      this.resetStep1()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs['embedded-step-0'].validate(valid => {
        if (this.$refs['embedded-step-1']) {
          this.$refs['embedded-step-1'].validate(valid2 => callback(valid && valid2))
        } else {
          callback(valid)
        }
      })
    },
    applystep: function () {
      this.$emit('applystep')
    }
  },
}
</script>

<style scoped>
.layout-detail-two-columns::v-deep .left-col {
  overflow-x: hidden;
}
.invoice-step > div:not(:first-child) {
  margin-top: 5px;
}
.invoice-step > div:not(:last-child) {
  margin-bottom: 5px;
}
</style>
